import React from 'react';

import Table from './component';

const TableContainer = ({ ...props }) => {
  return <Table {...props} />;
};

export default TableContainer;
